module.exports = __webpack_public_path__ + "assets/0cb90193908666854768539605f4f241.png";